"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFixScrollbarFlickering = createFixScrollbarFlickering;
exports.removeFixScrollbarFlickering = removeFixScrollbarFlickering;
// KLUDGE:
//
// Scrollbar flickering fix from Bootstrap
// https://github.com/twbs/bootstrap/blob/v4-dev/js/src/modal.js
//
// It injects an new element to calculate the scrollbarWidth. If there is a non
// floating scrollbar, when the modal is shown, it applies a right padding of
// the same width to the body and on elements with fixed position
// (.gl-is-sticky) The paddings are removed when the modal is closed This
// solution is hiding the scrollbar, preventing user to manually scroll with it
// and is more browser-independent than listening to the scroll events and
// blocking it

function getAllElementsWithFixedPosition() {
  return Array.from(document.querySelectorAll('.gl-is-sticky'));
}
function isBodyOverflowing() {
  var _document$body$getBou = document.body.getBoundingClientRect(),
    left = _document$body$getBou.left,
    right = _document$body$getBou.right;
  return left + right < window.innerWidth;
}
function getScrollbarWidth() {
  var scrollTemElement = document.createElement('div');

  // Note that you can't assign an object to scrollTemElement.style, that won't
  // work! keep all the property assignments individually.
  Object.assign(scrollTemElement.style, {
    position: 'absolute',
    top: '-9999px',
    width: '50px',
    height: '50px',
    overflow: 'scroll'
  });

  // Measure scrollbar width for padding body during modal show/hide
  document.body.appendChild(scrollTemElement);
  var scrollbarWidth = scrollTemElement.getBoundingClientRect().width - scrollTemElement.clientWidth;
  document.body.removeChild(scrollTemElement);
  return scrollbarWidth;
}
function adjustFixedElementPadding(currentScrollbarWidth, element) {
  var paddingRight = element.style.paddingRight;
  var padding = paddingRight ? parseFloat(paddingRight) : 0;
  element.dataset['paddingRight'] = "".concat(padding);
  element.style.paddingRight = "".concat(padding + currentScrollbarWidth, "px");
}
function resetFixedElementPadding(element) {
  var padding = element.dataset['paddingRight'];
  if (typeof padding !== 'undefined') {
    element.style.paddingRight = "".concat(padding, "px");
    element.dataset['paddingRight'] = '';
  }
}

//
// Public functions
//

/**
 * Create scrollbar fix. Reset padding right from fixed elements.
 */
function createFixScrollbarFlickering() {
  if (!isBodyOverflowing()) {
    return;
  }
  var scrollbarWidth = getScrollbarWidth();
  // Adjust fixed content padding
  getAllElementsWithFixedPosition().forEach(function (element) {
    adjustFixedElementPadding(scrollbarWidth, element);
  });
  adjustFixedElementPadding(scrollbarWidth, document.body);
}

/**
 * Remove scrollbar fix. Reset padding right from fixed elements.
 */
function removeFixScrollbarFlickering() {
  // Adjust fixed content padding
  getAllElementsWithFixedPosition().forEach(resetFixedElementPadding);
  // Restore body padding
  resetFixedElementPadding(document.body);
}